const frenchTraduction = {
    titleHome : 'Accueil',
    titleDoctor : 'Docteurs',
    scheduleNav : 'Lundi-vendredi',
    mainTitle : 'Vos consultations médicales à Bonnevoie',
    mainParagraph1 : 'Le Centre Médical Bonnevoie vous accueille du lundi au vendredi.',
    mainParagraph2 : 'Le Centre propose des consultations dispensées par quatre médecins généralistes et un médecin spécialiste en médecine uniquement sur rendez-vous.',
    mainParagraph3 : 'En cas de non-disponibilité de votre médecin habituel, un autre médecin peut vous recevoir.',
    mainParagraph31 : 'Vous pouvez envoyer votre demande de renouvellement d\'ordonnance par mail : ',
    mainParagraph32 : 'La demande sera traitée pendant les heures ouvrables du cabinet. Vous recevez un mail de confirmation quand l\'ordonnance est prête',
    mainParagraph4 : "Nous disposons aussi d'un laboratoire d'analyses médicales Ketterthill sans rendez-vous du lundi au vendredi de 7h00 à 10h00.",
    mainButton : 'Consulter les horaires des médecins',
    doctorTitle : 'Nos médecins',
    doctorAvailabilities : 'Voir les horaires',
    drObertinLanguages : 'Langues parlées : français , anglais , allemand , luxembourgeois',
    drBarretDeGassartLanguages : 'Langues parlées : français , anglais',
    drWeberLanguages : 'Langues parlées : français , anglais , allemand , luxembourgeois',
    drKrombachLanguages : 'Langues parlées : anglais , allemand , luxembourgeois',
    drDuReauLanguages : 'Langues parlées : ',
    appointment : 'Seulement sur rendez vous',
    contactTitle : 'Contact & accès',
    mainTitleAnnexe: 'Vos consultations médicales à Bonnevoie "Annexe"',
    mainParagraph1Annexe : 'Le Centre Médical Bonnevoie "Annexe" vous accueille du lundi au vendredi.',
    mainParagraph2Annexe : 'Le Centre propose des consultations dispensées par un médecin généraliste, un médecin pneumologue et un médecin spécialisé en médecine interne uniquement sur rendez-vous.',
    mainParagraph3Annexe : 'En cas de non-disponibilité de votre médecin habituel, un autre médecin peut vous recevoir.',
    mainParagraph31Annexe : 'Vous pouvez envoyer votre demande de renouvellement d\'ordonnance par mail : ',
    mainParagraph32Annexe : 'La demande sera traitée pendant les heures ouvrables du cabinet. Vous recevez un mail de confirmation quand l\'ordonnance est prête',
    mainParagraph4Annexe : 'Nous disposons aussi d\'un laboratoire d\'analyses médicales Ketterthill sans rendez-vous du lundi au vendredi de 7h00 à 10h00.',
}

export default frenchTraduction